// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2tfiM","label":"Completed_label__gSPVZ"};